import styled from 'styled-components'

export const Table = styled.table`
  width: ${({ width }) => width || '100%'};
  margin: 0 auto;
  border-collapse: separate;
  border-spacing: 0;
  background: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.radius.input};
  overflow: hidden;
  border: 1px solid ${props => props.theme.colors.border.medium};
  box-shadow: 0 1px 2px ${props => props.theme.colors.shadow.light};
  transition: all 0.3s ease;

  td, th {
    text-align: left !important; /* vince sugli inline textAlign per allineare tutte le colonne */
  }
`

export const Thead = styled.thead`
  transition: all 0.3s ease;

  tr {
    background: ${props => props.theme.colors.background.tertiary};
  }

  tr td {
    color: ${props => props.theme.colors.text.tertiary};
    border-bottom: 2px solid ${props => props.theme.colors.semantic.primary};
  }

  td {
    padding: ${({ compact }) => compact ? '0.3rem 0.5rem' : '0.5rem 0.75rem'};
    font-weight: 600;
    font-size: 0.75rem;
    font-family: ${props => props.theme.typography.fontFamily};
    letter-spacing: 0.04em;
    text-transform: uppercase;
    border: none;
    white-space: nowrap;

    &:first-child {
      border-top-left-radius: 5px;
    }

    &:last-child {
      border-top-right-radius: 5px;
    }
  }
`

export const Tbody = styled.tbody`
  tr {
    transition: background 0.2s ease;

    &:hover {
      background: ${props => props.theme.colors.semantic.primary + '1a'};
    }

    &:last-child td {
      border-bottom: none;
    }
  }
`

export const Trow = styled.tr`
  background: ${props => props.theme.colors.background.primary};
  transition: background 0.3s ease;

  td {
    border-bottom: 1px solid ${props => props.theme.colors.border.medium};
    transition: border-color 0.3s ease;
  }
`

export const Tcol = styled.td`
  padding: ${({ compact }) => compact ? '0.3rem 0.5rem' : '0.5rem 0.75rem'};
  text-align: ${({ align }) => align || 'center'};
  color: ${props => props.theme.colors.text.secondary};
  font-size: 0.9rem;
  font-weight: 400;
  font-family: ${props => props.theme.typography.fontFamily};
  vertical-align: middle;
  line-height: 1.3;
  transition: color 0.3s ease;

  &:has(svg) {
    cursor: pointer;
  }

  svg {
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.15);
      color: ${props => props.theme.colors.semantic.primary};
    }
  }
`
